<template>
  <PlacementsPill
    :total="column.hiresCount"
    :active="column.activeHiresCount"
    :all-url="allUrl"
    :active-url="activeUrl"
    :total-data-test="`agency-client-placements-${rowIndex}`"
    :active-data-test="`agency-client-active-placements-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { HireActiveStatus } from '@/gql/graphql'
import { agencyClientPlacementsUrl } from '@/components/Clients/placementFilters'
import PlacementsPill from '@/components/Clients/PlacementsPill.vue'

// Both status lists match counts the list precomputes: HireActiveStatus::placementListStatuses() and [ACTIVE].
const StaffingAgencyClientPlacementsColumn = graphql(`
  fragment StaffingAgencyClientPlacementsColumn on SupplierClient {
    id
    hiresCount(status: [OFFERED, READY, ACTIVE, ENDED, CANCELLED, TERMINATED])
    activeHiresCount: hiresCount(status: [ACTIVE])
    client {
      id
      name
    }
    managingCompany {
      id
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof StaffingAgencyClientPlacementsColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(StaffingAgencyClientPlacementsColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
const allUrl = computed(() => agencyClientPlacementsUrl(column.value))
const activeUrl = computed(() => agencyClientPlacementsUrl(column.value, [HireActiveStatus.Active]))
</script>
